export const environment = {
  production: true,
  version: '6a552282ed',
  site_version: 'SITE_VERSION'
};
